import './async-form-submission.scss';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslate, T } from 'shared/helper/translate';
var AsyncFormSubmission = function AsyncFormSubmission(_ref) {
  var processing = _ref.processing,
    label = _ref.label,
    _ref$testAttribute = _ref.testAttribute,
    testAttribute = _ref$testAttribute === void 0 ? null : _ref$testAttribute;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "mb-3 float-end async-form-submission"
  }, processing ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }) : null, /*#__PURE__*/React.createElement("button", {
    "aria-label": t(label),
    type: "submit",
    disabled: processing,
    className: "btn btn-primary btn-squared",
    "data-cy": testAttribute,
    "data-track": "click",
    "data-track-action": "button click",
    "data-track-label": "login"
  }, /*#__PURE__*/React.createElement(T, {
    source: label
  })));
};
export default AsyncFormSubmission;